import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/site";

const Privacy = () => (
  <section className="pt-32 sm:pt-40 pb-24" data-testid="privacy-page">
    <div className="mx-auto max-w-3xl px-4 sm:px-8">
      <Reveal y={16}>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber">Legal</p>
        <h1 className="mt-4 font-display font-black uppercase tracking-tight text-5xl sm:text-7xl leading-[0.9]">
          Privacy Policy
        </h1>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
          {CONTACT.company}
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-12 space-y-8 text-sm sm:text-base text-slate-400 leading-relaxed">
        <p>
          This Privacy Policy explains how {CONTACT.company} ("MAXIMUS TREADS", "we", "us") collects, uses and
          protects information you provide when you use this website or submit an enquiry.
        </p>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">1. Information we collect</h2>
          <p className="mt-3">
            When you submit a quote request or enquiry, we collect the details you provide: your name, company
            name, phone number, email address, location, product of interest, estimated volumes and any message
            content. We do not collect payment information — this website does not offer online checkout.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">2. How we use it</h2>
          <p className="mt-3">
            We use your information solely to respond to your enquiry, prepare quotations and communicate about
            our products — precured tread rubber, bonding gum and vulcanising solution. We do not sell or rent
            your personal information to third parties.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">3. Storage & security</h2>
          <p className="mt-3">
            Enquiry details are stored securely and accessed only by authorised members of our team for the
            purpose of handling your request.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">4. Your choices</h2>
          <p className="mt-3">
            You may ask us to update or delete your enquiry details at any time by writing to{" "}
            <a href={`mailto:${CONTACT.email}`} className="text-amber hover:underline" data-testid="privacy-email-link">{CONTACT.email}</a>.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">5. Contact</h2>
          <p className="mt-3">
            For privacy questions, contact {CONTACT.company}, {CONTACT.addressLines[0]}, {CONTACT.addressLines[1]} —
            phone {CONTACT.phones.map((p) => `+91 ${p}`).join(" / ")} or email {CONTACT.email}.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Privacy;
